import BasicChartTooltip from "components-for/charts/basic-chart-tooltip";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Box, BoxContent, BoxHeader, BoxHeading, BoxSubheading } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";
import { IInteractionsCount } from "@edgetier/watchtower-types";
import { IProps } from "./interactions-state-chart.types";
import { SpinnerUntil } from "@edgetier/components";
import "./interactions-state-chart.scss";

/**
 * Chart to display how many interactions are in each state
 */
const InteractionsStateChart: FunctionComponent<IProps> = ({
    blockedCount,
    deflectingCount,
    handlingCount,
    isLoading,
    queuingCount,
    wrapUpCount,
}) => {
    return (
        <Box className="interactions-state-chart">
            <BoxHeader>
                <BoxHeading>Interactions State</BoxHeading>
                <BoxSubheading>Number of live interactions grouped by state</BoxSubheading>
            </BoxHeader>
            <BoxContent>
                <SpinnerUntil<IInteractionsCount<Date>[]>
                    data={[
                        {
                            count: blockedCount,
                            interactionState: "Snoozed",
                        },
                        {
                            count: queuingCount,
                            interactionState: "Queuing",
                        },
                        {
                            count: deflectingCount,
                            interactionState: "Deflecting",
                        },
                        {
                            count: handlingCount,
                            interactionState: "Active",
                        },
                        {
                            count: wrapUpCount,
                            interactionState: "Wrap-Up",
                        },
                    ]}
                    isReady={!isLoading}
                >
                    {(chartData) => (
                        <ResponsiveContainer height="100%" width="100%">
                            <BarChart data={chartData}>
                                <CartesianGrid />
                                <Bar dataKey="count" radius={5} />
                                <XAxis dataKey="interactionState" />
                                <YAxis tickFormatter={(value) => value} />
                                <Tooltip
                                    isAnimationActive={false}
                                    content={({ active, payload }) =>
                                        active &&
                                        Array.isArray(payload) &&
                                        typeof payload[0].value === "number" && (
                                            <BasicChartTooltip
                                                frequency={payload[0].payload.count}
                                                label="interactions"
                                            />
                                        )
                                    }
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    )}
                </SpinnerUntil>
            </BoxContent>
        </Box>
    );
};

export default memo(InteractionsStateChart);
